type FeatureFlag = {
  value: string;
  description: string;
};

/**
 * IMPORTANT, When adding a new feature flag, please add team, name, and description.
 *
 * Teams are ENG, SUPPORT, PRODUCT
 */
export const featureFlags: FeatureFlag[] = [
  {
    value: "prevent-theme-header-footer",
    description:
      "(SUPPORT) Prevents theme-defined headers and footers from being automatically applied.",
  },
  {
    value: "archived-pages",
    description:
      "(SUPPORT) Enables support for managing and restoring archived pages.",
  },

  {
    value: "component-previews",
    description:
      "(ENG, Gabe) Renders component JSON outside the canvas instead of screenshots.",
  },
  {
    value: "write-through-products-sync",
    description:
      "(ENG, Noah) When loading products, we request them from the storefront API if possible and write them through to the database.",
  },
  {
    value: "replo-agent-opus",
    description:
      "(ENG, Gabe) Uses Claude Opus 4.5 model for chat agent instead of Sonnet.",
  },
  {
    value: "agent-launch-modal",
    description:
      "(PRODUCT, Yuxin) Auto-surfaces the Agent Launch letter popup on the dashboard for eligible non-agent, non-Shopify workspaces; entering creates an agent project directly.",
  },
  {
    value: "shared-components",
    description:
      "(ENG, Ezra) Gates the site-level Site Components viewer and preview APIs.",
  },
  {
    value: "site-reports",
    description:
      "(PRODUCT, Yuxin) Gates the website-builder Site Reports (site audits) UI. Off by default (disabled in production) while evidence collection is broken; Page Audit is unaffected.",
  },
  {
    value: "replo-agent-model",
    description:
      "(ENG, Gabe) Multivariate: the variant name sets the main chat agent's model. Variants match an AgentModelChoice or OpenRouter slug kebab-cased to PostHog's charset (glm-4-6, anthropic-claude-sonnet-5). Explicit client-set model overrides still win; non-Anthropic choices route via OpenRouter automatically. Configure: https://app.posthog.com/project/17701/feature_flags/843182",
  },
  {
    value: "meta-ads-integration",
    description:
      "(ENG/PRODUCT, Kevin) Shows the Meta Ads (Meta Marketing API) integration card in the integrations catalog. Off by default while Meta App Review is pending; enable per-account for testing.",
  },
  {
    value: "element-version-r2-read",
    description:
      "(ENG, Patrick) Serves version-history payload reads from R2 (sha256-verified, with Postgres fallback) instead of element_version.component.",
  },
  {
    value: "buy-domains",
    description:
      "(ENG, Yuxin) Enables buying a domain through Replo: search, registrant contact, and checkout. Gates acquisition only — managing an already-registered domain stays available.",
  },
];

export type FeatureName = FeatureFlag["value"] | `announcement_${string}`;

// NOTE (Cole, 2026-07-20): email is the distinct_id everywhere (a UUID would change rollout buckets); person_properties covers unstored persons.
export function buildPosthogDecideRequestBody({
  token,
  email,
  groups,
}: {
  token: string;
  email: string;
  groups?: { project?: string; workspace?: string };
}) {
  return {
    token,
    distinct_id: email,
    person_properties: { email },
    ...(groups ? { groups } : {}),
  };
}
